import { Layout } from "@/components/layout/Layout";
import { getStrapiCollection, getStrapiEntity } from "@/utils/strapi";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { page404 } from "@/const/page404";
import { createQueryDepartmentPage } from "@/strapiQuery/departmentPage";
import {
  formatFirstDepartmentPage,
  StrapiDepartmentPage,
} from "@/utils/formatDepartmentPage";
import { DepartmentDetails } from "@/interfaces/departmentDetails";
import { sendFetchRequest } from "@/utils/sendFetchRequest";
import { NetworkError } from "@/interfaces/errors/networkError";
import { routes } from "@/routes/routes";
import { ReviewsConst } from "@/components/common/reviewsBlock/ReviewsBlock";
import { queryReviewsConst } from "@/strapiQuery/queryReviewsConst";

type GetStaticPropsParams = LoadI18nMessagesProps & {
  params: { slug: string };
};

const SLUG_NOT_FOUND_ERROR_CODE = 422;

export const getStaticProps = async (ctx: GetStaticPropsParams) => {
  const layout = await getStrapiEntity<Layout>("layout", "");
  const reviewsConst = await getStrapiEntity<ReviewsConst>(
    "reviews-const",
    queryReviewsConst
  );
  const intlMessages = loadIntlMessages(ctx);

  let department: DepartmentDetails;
  try {
    department = await sendFetchRequest(`/states/v1/${ctx.params.slug}`).then(
      (json: DepartmentDetails) => json
    );
  } catch (error) {
    if (
      error instanceof NetworkError &&
      error.statusCode === SLUG_NOT_FOUND_ERROR_CODE
    ) {
      return page404;
    }
    throw error;
  }

  const strapiDepartmentPages = await getStrapiCollection<StrapiDepartmentPage>(
    "department-pages",
    createQueryDepartmentPage(ctx.params.slug)
  );

  if (strapiDepartmentPages.length === 0) {
    return page404;
  }

  const departmentPageContent = formatFirstDepartmentPage(
    strapiDepartmentPages
  );

  return {
    props: {
      layout,
      reviewsConst,
      intlMessages,
      department,
      slug: ctx.params.slug,
      ...departmentPageContent,
      defaultCanonicalRoute: routes.departmentPage(ctx.params.slug),
    },
    revalidate: 10,
  };
};

export const getStaticPaths = () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export { DepartmentPage as default } from "@/components/pages/agencies/departmentPage/DepartmentPage";
